import React from 'react';
import cloudUploadSVG from '../../../../assets/svg/cloud-upload-white.svg';

interface IProps {
    isRapidQuoteFlow: boolean;
}

export const WelcomeHeader = ({ isRapidQuoteFlow }: IProps) => (
    <div className="text-center mb-8">
        <h3 className="text-3xl font-bold text-slate-800 mb-3">Get an Instant Manufacturing Quote</h3>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto">Upload your 3D files or 2D files to get started</p>
    </div>
);
